export const PATH_SYSTEM_ADMIN = '/system-admin'
export const PATH_RELEASE_LIST = `${PATH_SYSTEM_ADMIN}/releases`
export const PATH_RELEASE_CREATE = `${PATH_SYSTEM_ADMIN}/releases/create`
export const PATH_RELEASE_EDIT = `${PATH_SYSTEM_ADMIN}/releases/edit`